import React, { useState } from 'react';
import { deleteSelf, logout } from '../services/auth.service';
import DeleteButton from './DeleteButton';
import Feedback from './Feedback';

const DeleteSelf: React.FC = () => {
  const [errors, setErrors] = useState([] as string[]);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');

  const handleSave = async () => {
    setErrors([]);

    if (password === '') {
      setErrors(['Please enter your password']);
      return;
    }

    setLoading(true);
    const result = await deleteSelf(password);
    if (result.success) {
      logout();
      window.location.href = '/Account/Login?deletedSelf=true';
    } else {
      setErrors(result.errors);
      setLoading(false);
    }
  };

  return (
    <form className="content-form">
      <Feedback messages={errors} type="error" />
      <p>Would you like to delete your account?</p>
      <input
        type="password"
        placeholder="Current password"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className="button-container">
        <DeleteButton
          onClick={handleSave}
          className="delete"
          isLoading={loading}
          message="Are you sure you want to delete your account?  You won't have access to any of the content you've created.  This action is not possible to be undone.  Are you sure?"
        >
          Delete
        </DeleteButton>
      </div>
    </form>
  );
};

export default DeleteSelf;
